import type { TrackingPropsInterface } from '../../utils/enums/enums';
import type { MMediaSelectorProps } from '../../molecules/MMediaSelector/MMediaSelector.types';

export enum OBannerFeatureContentAlignment {
  Left = 'Left',
  Center = 'Centered',
}

export enum OBannerFeatureLayout {
  Default = 'Default',
  Reverse = 'Reverse',
}

export interface OBannerFeatureTextBlockSimple {
  aEyebrow?: {
    eyebrowText?: string | null;
  };
  aHeader?: {
    text?: string | null;
    size?: string | null;
    headerTag?: string | null;
  };
  /**
   * @deprecated Use the top-level `mParagraph` prop instead. The body now renders
   * as an `MParagraph` (with 11-line truncation and a see-more/see-less control).
   */
  aBody?: {
    bodyText?: string | null;
    size?: string | null;
    color?: string | null;
  };
}

export interface OBannerFeatureEyebrow {
  eyebrowText?: string | null;
}

export interface OBannerFeatureHeader {
  text?: string | null;
  size?: string | null;
  headerTag?: string | null;
}

export interface OBannerFeatureParagraph {
  /** AEM may deliver this as the string `'true'`/`'false'`; both forms accepted. */
  truncated?: boolean | string | null;
  aBody?: {
    bodyText?: string | null;
    size?: string | null;
    color?: string | null;
  };
}

export interface OBannerFeatureButton {
  buttonText?: string | null;
  /** CTA style authored in AEM (e.g. `Primary`, `Secondary`, `Tertiary`). */
  type?: string | null;
  /**
   * @deprecated AEM delivers the CTA style on `type`. Retained as a fallback
   * for any consumer still passing `buttonType`.
   */
  buttonType?: string | null;
  ctaLink?: string | null;
  openInANewTab?: string | null;
}

export interface OBannerFeatureImage {
  image?: {
    damPath?: string;
    assetPath?: string;
    altText?: string;
    dynamic?: boolean;
    enableSmartCrop?: boolean;
  };
}

export interface OBannerFeatureProps {
  contentAlignment?: OBannerFeatureContentAlignment;
  layout?: OBannerFeatureLayout;
  /** Top-level eyebrow. Falls back to `mTextBlockSimple.aEyebrow` for legacy consumers. */
  aEyebrow?: OBannerFeatureEyebrow;
  /** Top-level header. Falls back to `mTextBlockSimple.aHeader` for legacy consumers. */
  aHeader?: OBannerFeatureHeader;
  /** Truncatable body copy. Falls back to `mTextBlockSimple.aBody` for legacy consumers. */
  mParagraph?: OBannerFeatureParagraph;
  /**
   * @deprecated Prefer top-level `aEyebrow` / `aHeader` / `mParagraph`. Retained as a
   * data-only fallback source for legacy consumers; it is no longer rendered as an
   * `MTextBlockSimple` component.
   */
  mTextBlockSimple?: OBannerFeatureTextBlockSimple;
  mButton?: OBannerFeatureButton;
  /** Secondary CTA rendered alongside `mButton` (e.g. RLM deep link). */
  mButton2?: OBannerFeatureButton;
  /**
   * @deprecated Use `mMediaSelector.mMediaImage.aImage` instead. Retained for
   * backwards compatibility; when `mMediaSelector` is absent, `aImage` is mapped
   * into an image media slot.
   */
  aImage?: OBannerFeatureImage;
  /** Media slot supporting image, carousel, CTA thumbnail, and video variants. */
  mMediaSelector?: MMediaSelectorProps;
  trackingProperties?: TrackingPropsInterface;
}
